import "react";
import { jsxs as e, jsx as r } from "react/jsx-runtime";
import { karwei_nl as c } from "@intergamma/theme";
import { ThemeProvider as s, createGlobalStyle as n } from "styled-components";
import { t as l } from "./theme-COnfrwW_.js";
const t = `:root {
  --colors-primary: #111316;
  --colors-black: #000;
  --colors-white: #fff;
  --colors-grey100: #f1f4f8;
  --colors-grey200: #dce1e8;
  --colors-grey300: #abb3bf;
  --colors-grey400: #878e9c;
  --colors-grey500: #5b6573;
  --colors-grey600: #4b525b;
  --colors-success: #0bba5f;
  --colors-success800: #307c30;
  --colors-success300: rgb(11 186 95 / 10%);
  --colors-error: #e55026;
  --colors-error800: #b93a16;
  --colors-error300: rgb(229 80 38 / 10%);
  --colors-warning: rgb(254 197 9 / 20%);
  --colors-info: var(--colors-grey100);
  --colors-cta: #fd7d0a;
  --colors-cta800: #c36231;
}
`;
function y({ children: o }) {
  return /* @__PURE__ */ e("div", { children: [
    /* @__PURE__ */ r(a, {}),
    /* @__PURE__ */ r(s, { theme: { ...c, ...l }, children: o })
  ] });
}
const a = n`
  ${t}
`;
export {
  y as KarweiTheme
};
